module.exports = __webpack_public_path__ + "static/media/sr.8fed71b6.svg";